import React from "react";

import { projects } from "../../Data";

import Card from "../card/Card";

import { Wrapper, Content } from "./ProjectsList.styles";

const ProjectsList = () => {
  return (
    <Wrapper>
      <Content>
        <h1>My Projects</h1>
        {projects.map((project, index) => {
          return (
            <Card
              key={index}
              // title={project.title}
              // description={project.title}
              // stack={project.stack}
              // buttons={[["Case Study"], ["Code"], ["Blob"]]}

              object={project}
            />
          );
        })}
      </Content>
    </Wrapper>
  );
};

export default ProjectsList;
